<template>
  <div class="core">
    <div class="layui-layer-title" style="cursor: move;">{{title}}</div>
    <div class="layui-layer-content">
      <div class="layui-layer-wrap">
        <div class="form-collapse">
          <div class="info">
            <layui-form ref="serviceForm" :show-form="true" :rule="service_form_rule" :requestUniqueId="requestId" :after-save="handleAfterSave">
              <template slot-scope="{scope}">
                <div class="layui-form">
                  <template>
                    <layui-collapse>
                      <div class="layui-colla-item">
                        <h2 class="layui-colla-title">服务商基本信息</h2>
                        <div class="layui-colla-content layui-show">
                          <div class="layui-form-item-one">
                            <div class="layui-form-item" v-if="formType === 'edit' || formType === 'browser'">
                              <label class="layui-form-label">服务商编号：
                              </label>
                              <div class="layui-input-inline" style="width: 30%;">
                                <input v-if='isBrowserStatus' type="text" :disabled="isBrowserStatus" v-model="config.form.SERVICE_NUM" autocomplete="off" class="layui-input layui-disabled"  name="STORE_BH"  placeholder="请输入服务商编号" />
                                <input v-else type="text" :disabled="isBrowserStatus" v-model="config.form.SERVICE_NUM" autocomplete="off" class="layui-input layui-disabled"  name="STORE_BH"  placeholder="请输入服务商编号" />
                              </div>
                            </div>
                            <div class="layui-form-item">
                              <label class="layui-form-label">
                                <span class="x-red">*</span>服务商名称：
                              </label>
                              <div class="layui-input-inline" style="width: 30%;">
                                <input type="text" :disabled="isBrowserStatus" v-model="config.form.SERVICE_NAME" autocomplete="off" :class="isBrowserStatus ? 'layui-input layui-disabled' : 'layui-input'"  name="SERVICE_NAME"  placeholder="请输入服务商名称" />
                              </div>
                            </div>
                            <div class="layui-form-item">
                              <label class="layui-form-label">
                                <span class="x-red">*</span>服务商性质：
                              </label>
                              <div class="layui-input-inline" style="width: 30%;">
                                <layui-radio v-model="config.form.SERVICE_NATURE" name="SERVICE_NATURE"  :enabled="!isBrowserStatus">
                                  <input type="radio" value="0" title="公司" />
                                  <input type="radio" value="1" title="个人" />
                                </layui-radio>
                              </div>
                            </div>
                            <div class="layui-form-item">
                              <label class="layui-form-label">
                                <span class="x-red">*</span>服务商类型：
                              </label>
                              <div class="layui-input-inline" style="width: 30%;">
                                <layui-select
                                  :enabled="!isBrowserStatus"
                                  name="SERVICE_TYPE"
                                  table-name="DB_DICTIONARY"
                                  text-field="DIC_NAME"
                                  value-field="DIC_CODE"
                                  :queryCondition="{'DIC_CATEGORY:0' : '服务商类型', 'DIC_PCODE:3': '-1'}"
                                  :show-null-option="true"
                                  :enable-search="true"
                                  v-model="config.form.SERVICE_TYPE"
                                ></layui-select>
                              </div>
                            </div>
                            <div class="layui-form-item">
                              <label class="layui-form-label"><span class="x-red">*</span>所属地：
                              </label>
                              <div class="layui-input-inline" style="width: 30%;">
                                <region-select
                                  :enabled="!isBrowserStatus"
                                  ref="ssd"
                                  v-model="config.form.SSD"
                                  @change="change"
                                ></region-select>
                              </div>
                            </div>
                            <div class="layui-form-item">
                              <label class="layui-form-label">
                                <span class="x-red">*</span>地址：
                              </label>
                              <div class="layui-input-inline" style="width: 30%;">
                                <input type="text" :disabled="isBrowserStatus" v-model="config.form.ADDRESS" autocomplete="off" :class="isBrowserStatus ? 'layui-input layui-disabled' : 'layui-input'" name="ADDRESS"  placeholder="请输入地址" />
                              </div>
                            </div>
                            <div class="layui-form-item">
                              <label class="layui-form-label">
                                <span class="x-red">*</span>联系人姓名：
                              </label>
                              <div class="layui-input-inline" style="width: 30%;">
                                <input type="text" :disabled="isBrowserStatus" v-model="config.form.CONTACT_PERSON" autocomplete="off" :class="isBrowserStatus ? 'layui-input layui-disabled' : 'layui-input'"  name="CONTACT_PERSON"  placeholder="请输入联系人姓名" />
                              </div>
                            </div>
                            <div class="layui-form-item">
                              <label class="layui-form-label">
                                <span class="x-red">*</span>联系电话：
                              </label>
                              <div class="layui-input-inline" style="width: 30%;">
                                <input type="text" :disabled="isBrowserStatus" v-model="config.form.PHONE_NUM" autocomplete="off" :class="isBrowserStatus ? 'layui-input layui-disabled' : 'layui-input'"  name="PHONE_NUM"  placeholder="请输入联系电话" />
                              </div>
                            </div>
                            <div class="layui-form-item">
                              <label class="layui-form-label"><span class="x-red" v-if="config.form.SERVICE_NATURE == '1'">*</span>身份证号：</label>
                              <div class="layui-input-inline" style="width: 30%;">
                                <input type="text" :disabled="isBrowserStatus" v-model="config.form.ID_CARD" autocomplete="off" :class="isBrowserStatus ? 'layui-input layui-disabled' : 'layui-input'"  name="ID_CARD"  placeholder="请输入身份证号" />
                              </div>
                            </div>
                            <div class="layui-form-item">
                              <label class="layui-form-label">是否开票：</label>
                              <div class="layui-input-inline" style="width: 30%;">
                                <layui-radio v-model="config.form.IS_BILL" name="IS_BILL" :enabled="!isBrowserStatus">
                                  <input type="radio" value="0" title="否" />
                                  <input type="radio" value="1" title="是" />
                                </layui-radio>
                              </div>
                            </div>
                            <div class="layui-form-item" v-show="config.form.IS_BILL == '1'">
                              <label class="layui-form-label"><span class="x-red" v-if="config.form.SERVICE_NATURE == '0'">*</span>开票名称：</label>
                              <div class="layui-input-inline" style="width: 30%;">
                                <input type="text" :disabled="isBrowserStatus" v-model="config.form.BILL_NAME" autocomplete="off" :class="isBrowserStatus ? 'layui-input layui-disabled' : 'layui-input'"  name="BILL_NAME"  placeholder="请输入开票名称" />
                              </div>
                            </div>
                            <div class="layui-form-item" v-show="config.form.IS_BILL == '1'">
                              <label class="layui-form-label"><span class="x-red" v-if="config.form.SERVICE_NATURE == '0'">*</span>纳税人识别号：</label>
                              <div class="layui-input-inline" style="width: 30%;">
                                <input type="text" :disabled="isBrowserStatus" v-model="config.form.TAXPAPYER_NUM" autocomplete="off" :class="isBrowserStatus ? 'layui-input layui-disabled' : 'layui-input'"  name="TAXPAPYER_NUM"  placeholder="请输入纳税人识别号" />
                              </div>
                            </div>
                            <div class="layui-form-item" v-show="config.form.IS_BILL == '1'">
                              <label class="layui-form-label"><span class="x-red" v-if="config.form.SERVICE_NATURE == '0'">*</span>开户行：</label>
                              <div class="layui-input-inline" style="width: 30%;">
                                <input type="text" :disabled="isBrowserStatus" v-model="config.form.BANK" autocomplete="off" :class="isBrowserStatus ? 'layui-input layui-disabled' : 'layui-input'"  name="BANK"  placeholder="请输入开户行" />
                              </div>
                            </div>
                            <div class="layui-form-item" v-show="config.form.IS_BILL == '1'">
                              <label class="layui-form-label"><span class="x-red" v-if="config.form.SERVICE_NATURE == '0'">*</span>银行卡号：</label>
                              <div class="layui-input-inline" style="width: 30%;">
                                <input type="text" :disabled="isBrowserStatus" v-model="config.form.BANK_NUM" autocomplete="off" :class="isBrowserStatus ? 'layui-input layui-disabled' : 'layui-input'"  name="BANK_NUM"  placeholder="请输入银行卡号" />
                              </div>
                            </div>

                            <div class="layui-form-item" v-show="config.form.IS_BILL == '0'">
                              <label class="layui-form-label"><span class="x-red" v-if="config.form.SERVICE_NATURE == '1'">*</span>开户行：</label>
                              <div class="layui-input-inline" style="width: 30%;">
                                <input type="text" :disabled="isBrowserStatus" v-model="config.form.BANK" autocomplete="off" :class="isBrowserStatus ? 'layui-input layui-disabled' : 'layui-input'"  name="BANK"  placeholder="请输入开户行" />
                              </div>
                            </div>
                            <div class="layui-form-item" v-show="config.form.IS_BILL == '0'">
                              <label class="layui-form-label"><span class="x-red" v-if="config.form.SERVICE_NATURE == '1'">*</span>银行卡号：</label>
                              <div class="layui-input-inline" style="width: 30%;">
                                <input type="text" :disabled="isBrowserStatus" v-model="config.form.BANK_NUM" autocomplete="off" :class="isBrowserStatus ? 'layui-input layui-disabled' : 'layui-input'"  name="BANK_NUM"  placeholder="请输入银行卡号" />
                              </div>
                            </div>

                            <div class="layui-form-item">
                              <label class="layui-form-label">备注：
                              </label>
                              <div class="layui-input-inline" style="width: 30%;">
                                <textarea :disabled="isBrowserStatus" v-model="config.form.BZ" autocomplete="off" :class="isBrowserStatus ? 'layui-textarea layui-disabled' : 'layui-textarea'"  name="BZ"  placeholder="请输入备注" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </layui-collapse>
                  </template>
                </div>
                <div class="layui-form-btn">
                  <div class="layui-footer">
                    <button class="layui-btn refresh" title="关闭" @click="handleBtnclick('close')">
                      关 闭
                    </button>
                    <button v-if='!isBrowserStatus' class="layui-btn" title="保存" @click="handleBtnclick('save')">
                      保 存
                    </button>
                  </div>
                </div>
              </template>
            </layui-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      requestId: 'serviceRequest',
      areaArr:[], // 地区码
      areaArrText:[], // 地区名
      service_form_rule: {
        SERVICE_NAME: {
          required: { message: '服务商名称不能为空'},
        },
        SERVICE_NATURE: {
          required: { message: '服务商性质不能为空'},
        },
        SERVICE_TYPE: {
          required: { message: '服务商类型不能为空'},
        },
        SSD: {
          required: { message: '所属地不能为空'},
        },
        ADDRESS: {
          required: { message: '地址不能为空'},
        },
        CONTACT_PERSON: {
          required: { message: '联系人姓名不能为空'},
        },
        PHONE_NUM: {
          required: { message: '联系电话不能为空'},
        },
      },
      config: {
        form: {
          SERVICE_NATURE: '1',
          IS_BILL: '0'
        }
      },
      formData: {},
      formType: 'add',
      title:'',
      isBrowserStatus: false
    }
  },
  mounted () {
    if(this.tabParam) {
      this.formData = this.tabParam.editRow;
      this.tableObj = this.tabParam.tableObj;
      this.formType = this.tabParam.formType;
      this.title = this.tabParam.title;

      if (this.formType === 'edit') {
        if(!Array.isArray(this.formData.SSD)){
          this.formData.SSD = this.formData.SSD.split(',')
        }
        this.config.form = this.formData;
      } else {
        if(!Array.isArray(this.formData.SSD)){
          this.formData.SSD = this.formData.SSD.split(',')
        }
        this.config.form = this.formData;
        this.isBrowserStatus = true
      }
    }
  },
  methods: {
    /**
     * 保存、关闭
     */
    change(val,fn){
      let arr = []
      let arrText = []
      fn.forEach(item=>{
        arr.push(item.id)
        arrText.push(item.text)
      })
      this.areaArr = arr
      this.areaArrText = arrText
      this.config.form.PROVINCE = this.areaArr[0] ? this.areaArr[0] : '';
      this.config.form.CITY = this.areaArr[1] ? this.areaArr[1] : '';
      this.config.form.DISTRICT = this.areaArr[2] ? this.areaArr[2] : '';
    },
    handleBtnclick(type) {
      switch (type) {
        case 'close': {
          this.baseComponent.closeComponent(this.tabParam.cloneMenu);
          if(this.tabParam.from == 'serviceRequestForm'){
            this.baseComponent.currentComponent = this.tabParam.sourceMenu;
          }else {
            this.baseComponent.loadComponentByName('serviceProvider');
          }
          break
        }
        case 'save': {
          this.config.form.SSD = this.areaArrText
          this.$refs.serviceForm.editRow = this.config.form;
          //动态添加必填项
          // SERVICE_NATURE=0 && IS_BILL=0   不校验
          // SERVICE_NATURE=0 && IS_BILL=1   开票名称  纳税人识别号  开户行  银行卡号
          // SERVICE_NATURE=1 && IS_BILL=0   开户行  银行卡号
          // SERVICE_NATURE=1 && IS_BILL=1   不校验
          if (this.config.form.SERVICE_NATURE === '0' &&　this.config.form.IS_BILL === '1') {
            if (!this.config.form.BILL_NAME) {
              layer.msg('开票名称不能为空', {icon: 5,shift: 6});
              return
            }

            if (!this.config.form.TAXPAPYER_NUM) {
              layer.msg('纳税人识别号不能为空', {icon: 5,shift: 6});
              return
            }

            if (!this.config.form.BANK) {
              layer.msg('开户行不能为空', {icon: 5,shift: 6});
              return
            }

            if (!this.config.form.BANK_NUM) {
              layer.msg('银行卡号不能为空', {icon: 5,shift: 6});
              return
            }
          }

          if (this.config.form.SERVICE_NATURE === '1' &&　this.config.form.IS_BILL === '0') {
            if (!this.config.form.BANK) {
              layer.msg('开户行不能为空', {icon: 5,shift: 6});
              return
            }

            if (!this.config.form.BANK_NUM) {
              layer.msg('银行卡号不能为空', {icon: 5,shift: 6});
              return
            }
          }

          if (this.config.form.SERVICE_NATURE === '1') {
            if (!this.config.form.ID_CARD) {
              layer.msg('身份证号不能为空', {icon: 5,shift: 6});
              return
            }
          }

          this.$refs.serviceForm.callableSave("YW_SERVICER");
          break
        }
        default: {
          break
        }
      }
    },
    handleAfterSave() {
      this.baseComponent.closeComponent(this.tabParam.cloneMenu);
      if(this.tabParam.from == 'serviceRequestForm'){
        this.$bus.$emit('serviceRequest_inner_addService');
        this.baseComponent.currentComponent = this.tabParam.sourceMenu;
      }else {
        this.baseComponent.loadComponentByName('serviceProvider');
        if (this.tableObj) {
          this.tableObj.pageInfo.pageIndex = 1
          this.tableObj.load()
        }
      }
    },
  }
}
</script>

<style>
/* .layui-input-inline{
  width: 30%!important
  } */
</style>



// WEBPACK FOOTER //
// src/components/person/servicePManage/serviceForm.vue